import pdfImage from 'src/assets/images/iconsMvpApp/Document PDF.svg';
import emptyDocument from 'src/assets/images/iconsMvpApp/Document.svg';
import styled from 'styled-components';
import React from 'react';

interface Props extends React.HTMLAttributes<HTMLImageElement> {
  type: string;
}

const getFileImgSource = (type: Props['type']): string => {
  if (type && type.toLocaleLowerCase() === 'pdf') {
    return pdfImage;
  }
  return emptyDocument;
};

export const FileIcon = styled.img.attrs((props: Props) => ({
  alt: 'File icon',
  src: getFileImgSource(props.type),
}))<Props>`
  width: 40px;
  height: 40px;
`;

export const MvpFileIcon = styled.img.attrs((props: Props) => ({
  alt: 'File icon',
  src: getFileImgSource(props.type),
}))<Props>`
  width: 30px;
  height: 30px;
`;
